<template lang="pug">
  v-select.user-select(:value.sync="selectedOption" @input="onInput" :options="options" placeholder="Select User")
</template>
<script>

import vSelect from 'vue-select'
import Security from '@/service/apis/Security'

export default {
  props: {
    value: {
      type: null
    }
  },
  data() {
    return {
      options: [],
      selectedOption: null
    }
  },
  created() {
    Security.listUsers({ size: 1000 })
      .then((resp) => {
        this.options = resp.data.content.map((o) => ({ value: o.id, label: o.username }))
      })
      .catch((e) => { this.$emit('error', e) })
  },
  methods: {
    onInput(opt) {
      this.$emit('input', opt)
    }
  },
  watch: {
    optionsValue() {
      if (this.optionsValue) {
        this.selectedOption = this.options.find((o) => o.value === this.value)
      }
    }
  },
  computed: {
    optionsValue() {
      if (this.value && this.options.length) {
        return true
      }
      return null
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/UserSelect.vue